import { jsxs, jsx } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import { PenIcon, TrashIcon } from "@graphiql/react";
import { CollectionItemRow } from "./collection-item-row.js";
import SvgUpload from "../icons/upload.js";
import SvgCheck from "../icons/check.js";
const CollectionRow = ({
  collection,
  expanded,
  onToggleExpand,
  readOnly = false,
  grabbed,
  onGrabToggle,
  onGrabMove,
  onGrabCancel,
  onRename,
  onDelete,
  onShareCollection,
  onOpenItem,
  onShare,
  onAnnounce,
  onDeleteItem,
  onMoveItem,
  onRenameItem
}) => {
  const [isRenaming, setIsRenaming] = useState(false);
  const [renameValue, setRenameValue] = useState(collection.name);
  const [confirmed, setConfirmed] = useState(false);
  const [confirmToken, setConfirmToken] = useState(0);
  useEffect(() => {
    if (!confirmed) {
      return;
    }
    const timer = setTimeout(() => setConfirmed(false), 1500);
    return () => clearTimeout(timer);
  }, [confirmed, confirmToken]);
  const runShareCollection = async () => {
    try {
      await onShareCollection(collection.id);
      onAnnounce("Shared collection to clipboard.");
      setConfirmed(true);
      setConfirmToken((t) => t + 1);
    } catch {
      onAnnounce("Could not share to clipboard.");
    }
  };
  const commitRename = () => {
    if (renameValue.trim()) {
      onRename(collection.id, renameValue.trim());
    }
    setIsRenaming(false);
  };
  return /* @__PURE__ */ jsxs("div", { className: "graphiql-collection-row", children: [
    /* @__PURE__ */ jsxs("div", { className: "graphiql-collection-header", children: [
      isRenaming ? /* @__PURE__ */ jsx(
        "input",
        {
          className: "graphiql-collection-rename-input",
          value: renameValue,
          autoFocus: true,
          onChange: (e) => setRenameValue(e.target.value),
          onBlur: commitRename,
          onKeyDown: (e) => {
            if (e.key === "Enter") {
              commitRename();
            }
            if (e.key === "Escape") {
              setRenameValue(collection.name);
              setIsRenaming(false);
            }
            e.stopPropagation();
          }
        }
      ) : /* @__PURE__ */ jsxs(
        "button",
        {
          type: "button",
          className: "graphiql-collection-toggle",
          "aria-expanded": expanded,
          "aria-label": `Toggle ${collection.name}`,
          onClick: onToggleExpand,
          children: [
            /* @__PURE__ */ jsx("span", { className: "graphiql-collection-chevron", "aria-hidden": "true", children: expanded ? "▾" : "▸" }),
            /* @__PURE__ */ jsx("span", { className: "graphiql-collection-name", children: collection.name })
          ]
        }
      ),
      /* @__PURE__ */ jsx("span", { className: "graphiql-collection-badge", children: collection.items.length }),
      /* @__PURE__ */ jsxs("div", { className: "graphiql-collection-header-actions", children: [
        !readOnly && /* @__PURE__ */ jsx(
          "button",
          {
            type: "button",
            className: "graphiql-collection-header-action",
            "aria-label": `Rename ${collection.name}`,
            title: "Rename",
            onClick: (e) => {
              e.stopPropagation();
              setRenameValue(collection.name);
              setIsRenaming(true);
            },
            children: /* @__PURE__ */ jsx(PenIcon, { "aria-hidden": "true" })
          }
        ),
        /* @__PURE__ */ jsx(
          "button",
          {
            type: "button",
            className: "graphiql-collection-header-action",
            "aria-label": `Share ${collection.name}`,
            title: "Share collection",
            "data-confirmed": confirmed || void 0,
            onClick: (e) => {
              e.stopPropagation();
              void runShareCollection();
            },
            children: confirmed ? /* @__PURE__ */ jsx(SvgCheck, { "aria-hidden": "true" }) : /* @__PURE__ */ jsx(SvgUpload, { "aria-hidden": "true" })
          }
        ),
        !readOnly && /* @__PURE__ */ jsx(
          "button",
          {
            type: "button",
            className: "graphiql-collection-header-action",
            "aria-label": `Delete ${collection.name}`,
            title: "Delete",
            onClick: (e) => {
              e.stopPropagation();
              onDelete(collection.id);
            },
            children: /* @__PURE__ */ jsx(TrashIcon, { "aria-hidden": "true" })
          }
        )
      ] })
    ] }),
    expanded && collection.items.length > 0 && /* @__PURE__ */ jsx("div", { className: "graphiql-collection-items", children: collection.items.map((item, i) => /* @__PURE__ */ jsx(
      CollectionItemRow,
      {
        item,
        collectionId: collection.id,
        index: i,
        readOnly,
        isGrabbed: (grabbed == null ? void 0 : grabbed.collectionId) === collection.id && grabbed.index === i,
        onGrabToggle: () => onGrabToggle(collection.id, i, item.id),
        onGrabMove,
        onGrabCancel,
        onOpen: onOpenItem,
        onShare,
        onAnnounce,
        onDelete: onDeleteItem,
        onMove: onMoveItem,
        onRenameItem
      },
      item.id
    )) }),
    expanded && collection.items.length === 0 && /* @__PURE__ */ jsx("div", { className: "graphiql-collection-empty-hint", children: readOnly ? "No operations here yet." : "No operations here yet. Save a query to add it to this collection." })
  ] });
};
export {
  CollectionRow
};
//# sourceMappingURL=collection-row.js.map
